/** `HelmRunStatus` (plus the effective `'abandoned'` reading `RunHistory`
 * receives) has no direct `AutobuildOutcome` analogue, so this maps onto the
 * Autobuild console's existing outcome vocabulary instead of declaring a
 * second one — split from `RunHistory.tsx` so that component file only
 * exports a component (react-refresh/only-export-components), matching
 * `quota-display.ts` / `adgs-sweep-outcome.ts` in `pages/autobuild/`.
 */
import type { HelmRunStatus } from '@a7y/platform-health/helm';
import type { AutobuildOutcome } from '@a7y/types';

export function toAutobuildOutcome(status: HelmRunStatus | 'abandoned'): AutobuildOutcome {
  switch (status) {
    case 'succeeded':
      return 'success';
    case 'running':
      return 'running';
    case 'failed':
    case 'abandoned':
      return 'failure';
  }
}
